export function stringifySortArray(sorts) {
    return sorts.map((val) => `${val.field},${val.sort}`).join("-");
}

export function createColumnsFromQuery(sort, columns) {
    return columns.map((c) => {
        const querySort = sort.split("-").find(s => {
            const [sField, _] = s.split(",");

            return c?.fieldName === sField;
        });

        if (!!querySort) {
            c = { ...c, sortValue: querySort.split(",")[1] };
        }

        return c;
    })
}

export function removeFilterFromKeys(stringSorts, keys) {
    const sorts = stringSorts?.split("-").filter((sort) => {
        const [key, _] = sort.split(",");

        return !keys.includes(key);
    }) ?? [];

    return sorts.join("-");
}

export function addStringSort(stringSorts, sortField, sortValue) {
    let sorts = [];
    if (!!stringSorts) {
        sorts = stringSorts.split("-").filter((stringSort) => {
            const [key, _] = stringSort.split(",");

            return key !== sortField;
        })
    }

    sorts.push(`${sortField},${sortValue}`);
    return sorts.join("-");
}